module.exports = __webpack_public_path__ + "static/img/3708_phase_function_Paper_Points.7c0e836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3708_phase_function_Paper_Points.png
// module id = NG49
// module chunks = 0